import _ from "lodash"

export const getYoutubeVideoId = link => {
  let videoId = null
  if (link.indexOf("youtu.be/") !== -1) {
    videoId = _.last(link.split("youtu.be/"))
  }

  if (link.indexOf("v=") !== -1) {
    videoId = link.split("v=")[1]
  }

  const ampersandPosition = videoId.indexOf("&")
  if (ampersandPosition !== -1) {
    videoId = videoId.substring(0, ampersandPosition)
  }

  return videoId
}
